module.exports = "<div>\n  <div class=\"modal-header\">\n    <h5 class=\"modal-title\" id=\"modal-title\" ng-bind=\"'AFTERHOURS_TITLE' | translate\"></h5>\n  </div>\n\n  <div class=\"modal-body\">\n      <p ng-bind=\"'AFTERHOURS_DESC' | translate\"></p>\n      <p class=\"after-hours-phone\" ng-bind=\"'AFTERHOURS_PHONE' | translate\"></p>\n  </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn btn-warning\"\n              ng-click=\"afterhours.$onClose($event)\">\n              {{ 'AFTERHOURS_CONFIRM' | translate }}\n      </button>\n    </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/booking/afterhours/afterhours.html
 ** module id = 330
 ** module chunks = 0
 **/